((($) => {

    let _burger = $('.js-burger');
    let _overlay = $('.js-overlay');
    let _sideMenu = $('.js-sideMenu');
    let _wrapper = _sideMenu.closest('.side-menu-wrapper');
    let _body = $('body');
    _body.on('click', '.js-burger', function () {
        _burger.addClass('active');
        _body.css('overflow', 'hidden');
        _overlay.fadeIn('fast', function () {
            _wrapper.addClass('active');
        });
    });
    _overlay.click(function () {
        _body.css('overflow', 'visible');
        _wrapper.removeClass('active');
        setTimeout(function () {
            _overlay.fadeOut('fast');
            _burger.removeClass('active');
        }, 250);
    });
    $('.js-closeSideMenu').click(function () {
        _body.css('overflow', 'visible');
        _wrapper.removeClass('active');
        setTimeout(function () {
            _overlay.fadeOut('fast');
            _burger.removeClass('active');
        }, 250);
    });
    $('.js-sub-menu').click(function (e) {
        e.preventDefault();
        $(this).closest('.has-sub').find('.side-menu--sub-ul').slideToggle();
    });

})(jQuery));
